import { ROVO_SECTION } from '@atlaskit/editor-common/quick-insert/keys';
import type { RegisteredItemRankResolver } from '@atlaskit/editor-common/registered-menu/item-rank';

export const getRovoChatQuickInsertRank: RegisteredItemRankResolver = ({ component }) =>
	component.type === ROVO_SECTION.type && component.key === ROVO_SECTION.key
		? { rank: 0.5 }
		: undefined;
